/** Product tour step indices — single source of truth for tour-aware UI logic */
export const TOUR_STEP = {
	welcome: 0,
	workspaceSwitcher: 1,
	workspaceSettings: 2,
	newProject: 3,
	projectCreateModal: 4,
	projectTile: 5,
	analysesTab: 6,
	sourcesTab: 7,
	importFile: 8,
	pasteText: 9,
	pasteModal: 10,
	waitArtifactProcessing: 11,
	startAnalysis: 12,
	waitArtifact: 13,
	primaryFile: 14,
	contextFiles: 15,
	template: 16,
	processDetailLevel: 17,
	generate: 18,
	analysisGenerating: 19,
	analysisStepperNext: 20,
	validateSummary: 21,
	exceptions: 22,
	regenerate: 23,
	chat: 24,
	goToModel: 25,
	handTool: 26,
	canvasNavigation: 27,
	spaceTool: 28,
	spaceToolPractice: 29,
	zoomIn: 30,
	zoomOut: 31,
	export: 32,
	modelRegenerate: 33,
	congratulations: 34,
} as const

export const PRODUCT_TOUR_STEP_COUNT = TOUR_STEP.congratulations + 1
